<script setup lang="ts">
const { showMoneyFormat } = useWallet();
const { closeModal } = useLayoutStore();

const props = defineProps<{
  amount: number;
}>();

const formattedAmount = computed(() => {
  if (!props.amount) return '';

  return showMoneyFormat({ value: props.amount / 100 });
});

const redirectToHome = () => {
  closeModal();
  navigateTo(localeLink('/'));
};

const goToWalletTransactions = () => {
  closeModal();
  navigateTo(localeLink('/user/wallet/transactions?select=user-wallet'));
};
</script>

<template>
  <section :class="$style.messageWrapper">
    <NuxtIcon
      class="text-primary mx-auto mt-5 text-8xl"
      :class="$style.icon"
      name="check_success"
    />

    <div :class="$style.textMessage">
      <p>{{ $t('account.wallet.withdraw_modal.cashout_success.title') }}</p>
      <span>
        {{ $t('account.wallet.withdraw_modal.cashout_success.subtitle') }}
      </span>
    </div>

    <section :class="$style.content">
      <article>
        <NuxtIcon
          class="text-[#868789]"
          name="money"
        />

        <span class="text-sm text-white">
          {{
            $t('account.wallet.withdraw_modal.cashout_success.amount_label')
          }}:
          <strong class="text-white">
            {{ formattedAmount }}
          </strong>
        </span>
      </article>
    </section>

    <button
      :class="$style.btnDefault"
      type="button"
      @click="redirectToHome"
    >
      <NuxtIcon name="check" />
      {{ $t('general.go_to_home') }}
    </button>

    <button
      :class="$style.btnLink"
      @click="goToWalletTransactions"
    >
      <strong :class="$style.footerLink">
        {{
          $t(
            'account.wallet.withdraw_modal.cashout_success.transactions_history',
          )
        }}
      </strong>
    </button>
  </section>
</template>

<style module lang="scss">
.messageWrapper {
  @apply flex flex-col justify-center items-center space-y-6 my-8;

  .textMessage {
    @apply w-5/6;
    @apply mt-8 text-center justify-center items-center px-6;

    p {
      @apply text-texts font-semibold;
    }
    span {
      @apply text-texts text-xs;
    }
  }

  .content {
    @apply sm:min-w-[300px] rounded-lg bg-[#333] px-6 py-6 space-y-4 border border-solid border-primary;

    article {
      @apply flex items-center gap-4  text-white;
    }
  }

  .icon {
    @apply text-primary mx-auto mt-5 font-[60px];
  }

  .btnDefault {
    @apply bg-button-bg text-button-text sm:min-w-[300px] py-2 px-4 rounded-md text-sm font-semibold whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed;
  }

  .btnLink {
    @apply text-links underline text-sm;
  }
}
</style>
